import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import SEO, { orgJsonLd, breadcrumbJsonLd } from "../components/SEO";
import Reveal from "../components/Reveal";
import { SectionHead } from "../components/StatsBar";
import { STATES } from "../data/siteData";

export default function LocationsHub() {
  return (
    <>
      <SEO
        title="Our Locations — CA & CS Services Across 31 Cities in 8 States | Complisure Counsultancy"
        description="Company registration, Virtual CFO and fundraising advisory across Telangana, Andhra Pradesh, Karnataka, Delhi NCR, Chandigarh, Madhya Pradesh, Tamil Nadu and Odisha."
        canonical="https://compliance-capital-1.preview.emergentagent.com/locations"
        jsonLd={[orgJsonLd, breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }])]}
      />
      <section className="relative overflow-hidden pb-20 pt-36">
        <div className="blob blob-float left-[-8%] top-[-8%] h-96 w-96 bg-brand-blue/10" />
        <div className="dot-grid absolute inset-0 opacity-[0.1]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.02em] text-brand-navy sm:text-5xl">
              Local desks, <span className="text-gradient">national standard</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-gray sm:text-lg">
              31 cities across 8 states — each with advisors who know the local ROC office, state incentives and the business culture on the ground.
            </p>
          </Reveal>

          <div className="mt-14 space-y-12">
            {STATES.map((st, si) => (
              <Reveal key={st.slug} delay={0.05}>
                <div data-testid={`hub-state-${st.slug}`} className="glass rounded-[28px] p-7 sm:p-9">
                  <div className="flex flex-wrap items-start justify-between gap-4">
                    <div>
                      <Link to={`/locations/${st.slug}`} data-testid={`hub-state-link-${st.slug}`} className="group flex items-center gap-3">
                        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-blue to-brand-sky text-white shadow-lg shadow-brand-blue/25">
                          <MapPin className="h-5 w-5" />
                        </span>
                        <div>
                          <h2 className="font-display text-2xl font-bold tracking-tight text-brand-navy group-hover:text-brand-blue">{st.name}</h2>
                          <p className="text-sm text-brand-gray">{st.tagline}</p>
                        </div>
                      </Link>
                    </div>
                    <Link to={`/locations/${st.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue transition-all hover:gap-3">
                      Explore {st.name} <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                  <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
                    {st.cities.map((c) => (
                      <Link
                        key={c.slug}
                        to={`/locations/${st.slug}/${c.slug}`}
                        data-testid={`hub-city-${c.slug}`}
                        className="group rounded-2xl border border-brand-blue/10 bg-white/60 p-4 transition-all hover:-translate-y-0.5 hover:bg-brand-ice"
                      >
                        <div className="flex items-center justify-between">
                          <p className="font-display text-sm font-bold text-brand-navy group-hover:text-brand-blue">{c.name}</p>
                          <span className="rounded-full bg-brand-ice px-2 py-0.5 text-[10px] font-semibold text-brand-blue">{c.tier}</span>
                        </div>
                        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-brand-gray">{c.keywords[0]}</p>
                      </Link>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
